import { combineReducers } from 'redux';
import { slice as notifications } from '../_BLL/notifications/slice';
import { slice as auth } from '../../pages/SignInPage/_BLL/slice';
import { slice as benchmarkSearch } from 'src/pages/MainPage/ui/_content/benchmark/_BLL/slice';
import { slice as analyzerSearch } from 'src/pages/MainPage/ui/_content/analyzer/_BLL/slice';
import { slice as mainSearch } from '../../pages/MainPage/api/mainSearch/slice';
import { slice as booleanSearch } from '../../pages/MainPage/api/booleanSearch/slice';
import { slice as savedQueries } from 'src/pages/MainPage/api/savedQueries/slice';
import { slice as mainSearchResults } from '../../pages/MainSearchResultsPage/api/searchResults/slice';
import { slice as mainSearchExcel } from '../../pages/MainSearchResultsPage/api/excelExport/slice';
import { slice as customizeColumns } from '../../pages/MainSearchResultsPage/api/customizeColumns/slice';
import { slice as savedColumns } from '../../pages/MainSearchResultsPage/api/collection/slice';
import { slice as database } from '../../pages/DatabasePage/api/database/slice';
import { slice as chatGPT } from '../../pages/MainPage/api/chatGPT/slice';

// Portfolio Analyzer
import { slice as portfolioAnalyzerPage } from 'src/pages/portfolio_analyzer_pages/api/analyzerPage/slice';
import { slice as newAnalysis } from 'src/pages/portfolio_analyzer_pages/api/analyzer/slice';

// Funds
import { slice as fundPage } from 'src/pages/funds_pages/api/slice';

// Country
import { slice as countryPage } from 'src/pages/CountryPage/api/slice';

// Benchmark
import { slice as benchmark } from 'src/pages/BenchmarkPage/api/benchmark/slice';

const mainSearchResultsReducers = {
	mainSearchResults: mainSearchResults.reducer,
	customizeColumns: customizeColumns.reducer,
	savedColumns: savedColumns.reducer,
	mainSearchExcel: mainSearchExcel.reducer,
	benchmarkSearch: benchmarkSearch.reducer,
	analyzerSearch: analyzerSearch.reducer,
};

const portfolioAnalyzerReducers = {
	newAnalysis: newAnalysis.reducer,
	portfolioAnalyzerPage: portfolioAnalyzerPage.reducer,
};

const fundsReducers = {
	fundPage: fundPage.reducer,
};

export const rootReducer = combineReducers({
	...mainSearchResultsReducers,
	...portfolioAnalyzerReducers,
	...fundsReducers,

	auth: auth.reducer,

	notifications: notifications.reducer,
	mainSearch: mainSearch.reducer,
	booleanSearch: booleanSearch.reducer,
	savedQueries: savedQueries.reducer,
	database: database.reducer,
	countryPage: countryPage.reducer,
	chatGPT: chatGPT.reducer,
	benchmark: benchmark.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
